import { Metamodel } from 'app/model/base/model';
import { FileBasedSettings } from './file-based-settings';
import { DatasetFormatType } from './dataflow-dataset-settings';
import { adfModelTypeMap } from '../../../registries/consts/adf-model-type-map-const';
import { DataFlowExpression } from '../dataflowexpression';
import { BooleanDataFlowType, StringDataFlowType, TimeStampDataFlowType } from '../dataflow-datatype';
import { IViolation } from 'app/model/base/annotation';
import { DataFlowSource } from '../dataflow-source';
import { DataFlowSink } from '../dataflow-sink';
import { IValidationContext } from 'shell-models-lib';

export enum TimeTravelOption {
    No,
    Timestamp,
    SnapshotId
}

@Metamodel.model({
    name: adfModelTypeMap.iceberg.dataflowSettings,
    validator: IcebergSettings.validateSettings
})
export class IcebergSettings extends FileBasedSettings {

    public static async validateSettings(settings: IcebergSettings, context: IValidationContext): Promise<IViolation[]> {
        const violations: IViolation[] = [];
        if (settings.transform instanceof DataFlowSource) {
            const source = settings.transform;
            if (source.isInlineDataset && source.datasetSettings.getFormat() === DatasetFormatType.Iceberg) {
                if (!settings.container.expression) {
                    violations.push({
                        context: source,
                        message: () => stringResources.Dataflow_RequireContainer
                    });
                } 
                if (!settings.folderPath.expression) {
                    violations.push({
                        context: source,
                        message: () => stringResources.Dataflow_RequireFolderPath
                    });
                }
                if ((settings.timeTravelOption === TimeTravelOption.SnapshotId && !settings.snapshotId.expression) ||
                (settings.timeTravelOption === TimeTravelOption.Timestamp && !settings.timestampAsOf.expression)) {
                    violations.push({
                        context: source,
                        message: () => stringResources.DataFlowSourcePanelIcebergDescriptionTimeTravelError
                    });
                }
            }
        }

        if (settings.transform instanceof DataFlowSink) {
            const sink = settings.transform;
            if (sink.isInlineDataset && sink.datasetSettings.getFormat() === DatasetFormatType.Iceberg) {
                if (!settings.container.expression) {
                    violations.push({
                        context: sink,
                        message: () => stringResources.Dataflow_RequireContainer
                    });
                } 
                if (!settings.folderPath.expression) {
                    violations.push({
                        context: sink,
                        message: () => stringResources.Dataflow_RequireFolderPath
                    });
                } 
            }
        }
        return violations.length > 0 ? violations : undefined;
    }
    
    public static datasetType = 'Iceberg';
    public nullValue: DataFlowExpression;
    public rowDelimiter: DataFlowExpression;
    public escapeCharacter: DataFlowExpression;
    public quoteCharacter: DataFlowExpression;
    public encoding: DataFlowExpression;

    public timeTravelOption: TimeTravelOption = TimeTravelOption.No;

    
    @Metamodel.attribute({
    })
    public snapshotId: DataFlowExpression;
    @Metamodel.attribute({
    })
    public timestampAsOf: DataFlowExpression;

    @Metamodel.attribute({
    })
    public overwrite: DataFlowExpression;

    @Metamodel.attribute({
    })
    public writeFormat: DataFlowExpression;

    public getDatasetType(): string {
        return DatasetFormatType.Iceberg;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Iceberg;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-20x20-Iceberg';
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.timestampAsOf = this.transform.createTemplatableExpression(TimeStampDataFlowType.TYPE);
        this.snapshotId = this.transform.createTemplatableExpression(StringDataFlowType.TYPE);
        this.overwrite = this.transform.createTemplatableExpression(BooleanDataFlowType.TYPE, 'false');
        this.writeFormat = this.transform.createTemplatableExpression(StringDataFlowType.TYPE);
    }
}
